import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicantService } from 'app/laas/applicant.service';
import { OpenDialog } from 'app/laas/dialog-for-cbs/dialog.component';
import { CibilReportService } from '../cibil-report.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { saveAs } from "file-saver/dist/FileSaver";

@Component({
  selector: 'cibil-view',
  templateUrl: './crif-report-view.component.html',
  styles: [],
  providers : [CibilReportService]
})
export class CrifReportViewComponent implements OnInit {


  imageBase64: string;
  showWaiting: boolean;
  pdfSource: string;
  score: any;
  imageBufferLink: string;
  repeatGetCreditScoreAPICount = 1;
  kccNewUat: string = environment.kccNewUat
  showButton: boolean;
  respLink: any;

  constructor(
    private cibil: CibilReportService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private applicant: ApplicantService,
    private https: HttpClient,
   
  ) { }

  ngOnInit() {
    this.showWaiting = true
    this.cibil.getCibilData().subscribe(resp=>{
      console.log(resp)
      if(resp && resp.result && resp.result.score &&
        (resp.message == "Report Generated Successfully" ||
        resp.message == "Credit Report fetched successfully")){                    
        if(resp.result.score.hasOwnProperty("bureauScore")){
          console.log('if check')
          this.score =  resp.result.score.bureauScore
        }
        else{
          console.log('else state')
          this.score = resp.result.score
        }
        if(resp.result.creditReportID){
          // this.imageBufferLink = `/file/PROFILE/${resp.result.creditReportID}`
          // this.applicant.getImage(this.imageBufferLink).subscribe(resp=>{
          //   console.log(resp)
          //   if(resp && resp.result && resp.result.imageData && resp.result.imageData.data ){
          //     this.imageBase64 = resp.result.imageData.data;
          //     // this.imageBase64 = Buffer.from(this.imageBufferData).toString('base64')
          //     console.log(this.imageBase64)
          //     this.pdfSource = `data:application/pdf;base64,${this.imageBase64}`
          //   }
  
          // })
          this.cibil.getCreditDoc().subscribe(resp=>{
            console.log('res credit', resp)
            if(resp){
            if(resp.success == true){
              this.showButton = true;
              this.respLink =  resp.link
            }
            else{
              this.showButton = false;
            }
          }
          })
        }
      }

    //  else if(resp && resp.result && resp.result.score &&
    //     (resp.message != "Report Generated Successfully" ||
    //     resp.message != "Credit Report fetched successfully")){
    //     this.repeatGetCreditScoreAPICount =this.repeatGetCreditScoreAPICount + 1;
    //     this.applicant.getCreditDataAP(this.repeatGetCreditScoreAPICount).subscribe(resp=>{   
    //       if(resp && resp.result && resp.result.score &&
    //         (resp.message == "Report Generated Successfully" ||
    //         resp.message == "Credit Report fetched successfully")){  
    //     this.score = resp.result.score  
    //     if(resp.result.creditReportID){
    //       this.imageBufferLink = `/file/PROFILE/${resp.result.creditReportID}`
    //       this.applicant.getImage(this.imageBufferLink).subscribe(resp=>{
    //         console.log(resp)
    //         if(resp && resp.result && resp.result.imageData && resp.result.imageData.data ){
    //           this.imageBase64 = resp.result.imageData.data;
    //           // this.imageBase64 = Buffer.from(this.imageBufferData).toString('base64')
    //           console.log(this.imageBase64)
    //           this.pdfSource = `data:application/pdf;base64,${this.imageBase64}`
    //         }
  
    //       })
    //     }
    //   }
    //   })
    //   }
      else{
        this.score = "Report Not Generated"
      }

      // const dialogRef = this.dialog.open(OpenDialog, {
      //   width: 'auto', height: 'auto',
      //   data: { heading: "Credit Report Score", content: resp && resp.result && resp.result.score?resp.result.score:""}
      // });
        this.showWaiting = false
      // if(resp && resp.result && resp.result.imageData){
      //   this.imageBase64 = Buffer.from(resp.result.imageData).toString('base64')
      //   console.log(this.imageBase64)
      //   this.showWaiting = false
      //   this.pdfSource = `data:application/pdf;base64,${this.imageBase64}`
      // }
    })
  }

  downloadPdf() {
    const linkSource = this.pdfSource
    const downloadLink = document.createElement("a");
    const fileName = "CreditReport.pdf";

    downloadLink.href = linkSource;
    downloadLink.target = '_blank'
    downloadLink.download = fileName;

    downloadLink.click();
  }
 
  downloadLink1(){
     this.downloadLink(this.respLink);      
  }
  
  downloadLink(respLink) {
    const linkSource = respLink
    const downloadLink = document.createElement("a");
    const fileName = 'CreditReport.pdf';   

    downloadLink.href = `${this.kccNewUat}/static/${linkSource}`;
    console.log(linkSource);

    this.https.get( downloadLink.href, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = 'CreditReport.pdf';
        saveAs(blob, fileName);
      },
      err => {
        console.log("err->", err);
      }
    );
  }


}
